import { BrowserRouter, Routes, Route, useSearchParams } from 'react-router-dom';
import Navbar from './components/Navbar';
import QuestionnairePage from './pages/QuestionnairePage';
import AdminPage from './pages/AdminPage';
import './App.css';

function AppShell() {
  const [searchParams] = useSearchParams();
  const isEmbed = searchParams.get('embed') === 'true';

  return (
    <div className={`App${isEmbed ? ' embed-mode' : ''}`}>
      {!isEmbed && <Navbar />}
      <main className="main-content">
          <Routes>
            <Route path="/" element={<QuestionnairePage />} />
            <Route path="/admin" element={<AdminPage />} />
          </Routes>
        </main>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppShell />
    </BrowserRouter>
  );
}

export default App;
